import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import axios from 'axios';
import './styles/App.css';
import './styles/monokai.css';
import Main from "./Main"
import Navbar from "./Navbar"

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: {},
      frameworks: {},
      collections: {},
    }
  }

  componentDidMount() {
    // this.setState({categories: {"computer-vision":{"id":1,"slug":"computer-vision","title":"Computer Vision","short_title":"CV","description":"Computer Vision: Object detection, boundary labelling, segmentation."},"natural-language-processing":{"id":2,"slug":"natural-language-processing","title":"Natural Language Processing","short_title":"NLP","description":"Natural Language Processing (NLP)."},"generative-models":{"id":3,"slug":"generative-models","title":"Generative Models","short_title":"Generative","description":"Generative Models, such as Generative Adversarial Networks (GANs), Variational Autoencoders (VAE), and more."},"reinforcement-learning":{"id":4,"slug":"reinforcement-learning","title":"Reinforcement Learning","short_title":"RL","description":"Where an agent learn how to behave in a environment by performing actions and seeing the results."},"unsupervised-learning":{"id":5,"slug":"unsupervised-learning","title":"Unsupervised Learning","short_title":"Unsupervised","description":"Unsupervised learning is a type of machine learning algorithm to draw inferences from datasets consisting of input data without labels."}},
    //   frameworks: {"tensorflow":{"title":"TensorFlow","slug":"tensorflow","link":"https://www.tensorflow.org","description":"TensorFlow™ is an open source software library for high performance numerical computation."},"caffe":{"title":"Caffe","slug":"caffe","link":"http://caffe.berkeleyvision.org","description":"Caffe is a deep learning framework made with expression, speed, and modularity in mind."},"caffe2":{"title":"Caffe2","slug":"caffe2","link":"https://caffe2.ai","description":"Caffe2 aims to provide an easy and straightforward way for you to experiment with deep learning and leverage community contributions of new models and algorithms."},"pytorch":{"title":"PyTorch","slug":"pytorch","link":"https://pytorch.org","description":"PyTorch is a deep learning framework for fast, flexible experimentation."},"mxnet":{"title":"MXNet","slug":"mxnet","link":"https://mxnet.incubator.apache.org","description":"Apache MXNet (incubating) is a deep learning framework designed for both efficiency and flexibility."},"keras":{"title":"Keras","slug":"keras","link":"https://keras.io","description":"Keras is a high-level neural networks API, written in Python and capable of running on top of TensorFlow, CNTK, or Theano."}}});

    axios.all([
      axios.get(process.env.REACT_APP_API + '/api/categories/'),
      axios.get(process.env.REACT_APP_API + '/api/frameworks/'),
      axios.get(process.env.REACT_APP_API + '/api/collections/'),
    ])
    .then(axios.spread((category_response, framework_response, collection_response) => {
      this.setState({categories: category_response.data, frameworks: framework_response.data, collections: collection_response.data});
    }));
  }

  render() {
    return <div className="App">
    <Helmet>
        <title>Model Zoo - Deep learning code and pretrained models for transfer learning, educational purposes, and more</title>
        <meta name="description" content="ModelZoo curates and provides a platform for deep learning researchers to easily find code and pre-trained models for a variety of platforms and uses. Find models that you need, for educational purposes, transfer learning, or other uses." />
    </Helmet>
    <Navbar frameworks={this.state.frameworks} categories={this.state.categories} collections={this.state.collections}/>
    <Main frameworks={this.state.frameworks} categories={this.state.categories}/>
    </div>
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js